import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getImage,
  getLanguageMenu,
  white
} from './helpers';

export const uptown: TrackingPageModel = {
  languageMenu: getLanguageMenu('Open Sans', '#4a4a4ab3'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Open Sans', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  background: {
    color: white,
    useBackgroundImage: false,
    imageUrl: getImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#dfa160ff',
    linksUnderline: false,
    backgroundColor: white,
    headerBackground: null,
    footerBackground: null,
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  orderCard: {
    borderRadius: 0,
    borderWidth: 1,
    borderColor: '#dfa160ff',
    backgroundColor: white,
    shadow: 'none',
    headerBackground: null,
    footerBackground: null,
    linksColor: '#dfa160ff',
    linksUnderline: false,
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 17,
    ...getFontConfig('Open Sans', '#000000ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Fira Sans', '#000000ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Open Sans', '#c13838b3')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#dfa160',
      borderColor: '#dfa160ff',
      borderRadius: 0,
      borderWidth: 2,
      shadow: 'none',
      ...getFontConfig('Open Sans', '#ffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: white,
      borderColor: '#ffffffff',
      borderRadius: 0,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Fira Sans', '#000000ff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 13,
        ...getFontConfig('Open Sans', '#767676ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#dfa16000',
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Open Sans', '#000000ff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#dfa160ff',
    borderColor: '#00ccff00',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Open Sans', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#dfa160ff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Open Sans', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(
    getAsset(
      '/images/themes/5c98e927f3ca2_upton-2x-7754f30e-a9aa-40f1-8561-37d1ae43c24c-x18-2x.png'
    )
  ),
  socialIcons: getSocialIcons('#dfa160ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  footer: {
    linksColor: '#dfa160ff',
    linksUnderline: false,
    backgroundColor: white,
    ...getFooterItems(),
    ...getFontConfig('Open Sans', '#4a4a4ab3')
  },
  header: {
    backgroundColor: white
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#dfa160ff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#dfa160ff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Open Sans', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Open Sans', '#a35b22ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Open Sans', '#4a4a4ab3')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Open Sans', '#000000ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#dfa160ff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#dfa160ff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#dfa160ff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#dfa160ff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Open Sans', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Open Sans', '#ab7628ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Open Sans', '#4a4a4ab3')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Open Sans', '#000000ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#dfa160ff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
